import React, { useState } from 'react'
import Breadcrumb from '../components/Breadcrumb'
import './work.scss'

function Work(title) {
    const [data, setData] = useState([]);
    const retriever = async () => {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://octaveinfosys.com/php/ShowImage.php', true)
        xhr.setRequestHeader("content-type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            setData(JSON.parse(this.responseText));
        }
        xhr.send(`fetch`);
    }
    retriever();
    return (
        <>

            {/* <!--header section start--> */}
            <Breadcrumb title={"Work Portfolio"} tag = "Portfolio" />
            {/* <!--header section end--> */}
            {/* <!--our work or portfolio section start--> */}




            <section className="our-portfolio-section ptb-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading text-center mb-4">
                                <strong className="color-secondary">Previous Project</strong>
                                <h2>Our Case Studies</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {data.map((item) => {
                            return (
                                <div className="col-md-4" key={item.id} >
                                    <div className="portfolio-container" id="MixItUp">
                                            <div className="portfolio-wrapper">
                                                <a href={item.url} rel="noreferrer" target="_blank">
                                                    <div className="content-overlay"></div>
                                                    <img className="img-fluid" src={`.././${item.image}`} alt="portfolio" />
                                                    <div className="content-details fadeIn-bottom text-white">
                                                        <h5 className="text-white mb-1">Live Preview <br /><i className="fas fa-paper-plane"></i></h5>
                                                    </div>
                                                </a>
                                                <div className="text-center p-4">
                                                    <h6 className="mb-1">{item.title} <i className="fas fa-paper-plane"></i></h6>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
            {/* <!--our work or portfolio section end--> */}


        </>
    )
}

export default Work
